var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "top_info"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Validators")]), _c('div', {
    staticClass: "content"
  }, [_vm.currentValidators ? _c('p', [_vm._v(" " + _vm._s(_vm.currentValidators.validators.length) + " " + _vm._s(_vm._f("pluralizeWithoutCount")(_vm.currentValidators.validators.length, 'Validator')) + " ")]) : _c('p', [_vm._v("N/A")])]), _c('div', {
    staticClass: "desc"
  }, [_vm.currentValidators ? _c('p', [_vm._v(" " + _vm._s(_vm.validatorsUptime.toFixed(2)) + "% (uptime) ")]) : _c('p', [_vm._v("N/A")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }